export default {
    DHM: 'DHM',
    HMS: 'HMS',
};
